import React, { useState, useEffect } from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import makeStyles from '@mui/styles/makeStyles';
import imgServices from 'src/assets/images/templates/t3/services.svg';
import imgAbout from 'src/assets/images/templates/t3/about.svg';
import imgTeam from 'src/assets/images/templates/t3/team.svg';
import ServiceCard from '../components/ServiceCard';
import {SectionTitle, SectionSubtitle} from '../components/SectionTitle';
import Header from '../components/Header';
import CustomButton from '../components/CustomButton';
import ImgLazyLoad from 'src/screens/WhiteLabels/Templates/shared/components/ImgLazyLoad';
import { ArrowForward, ArrowBack } from '@mui/icons-material';
import Carousel from 'react-elastic-carousel';
import { theme } from '../Template';
import SocialIcons from '../../shared/components/SocialIcons';
import { useCompanyData } from '../../shared/contexts/DataContext';
import imgProfile from 'src/assets/images/templates/profile.jpg';
import useMyPagination from '../../shared/logic/useMyPagination';
import MyPagination from '../../shared/components/MyPagination';
import { aboutImage, bannerImage as BannerImage } from '../../shared/logic/imagesFns';
import GetImageDimensions from '../../shared/logic/getImgDimensions';
import SectionLayout from '../../shared/layout/SectionLayout';
import { SectionTitle as T1SectionTitle, SectionSubtitle as T1SectionSubTitle, SectionParagraph as T1SectionParagraph } from '../../Template1/components/SectionTitle';
import { SectionTitle as T2SectionTitle, SectionSubtitle as T2SectionSubTitle, SectionParagraph as T2SectionParagraph } from '../../Template2/components/SectionTitle';
import { SectionTitle as T3SectionTitle, SectionSubtitle as T3SectionSubTitle, SectionParagraph as T3SectionParagraph } from '../components/SectionTitle';
import { SectionTitle as T4SectionTitle, SectionSubtitle as T4SectionSubTitle, SectionParagraph as T4SectionParagraph } from '../../Template4/components/SectionTitle';
import * as Components from '../../shared/sections';
import { textVariant, textClasses } from '../../shared/config';
import '../../shared/styles.css'
import CourseCard from '../components/CourseCard';
import { getLocalizedText } from "../../shared/logic/Utils";
// import {Services} from '../../shared/sections/services/Services1';
// import {Courses} from '../../shared/sections/courses/Course1';
const TitleList = {
  '1': T1SectionTitle,
  '2': T2SectionTitle,
  '3': T3SectionTitle,
  '4': T4SectionTitle,
};

const SubTitleList = {
  '1': T1SectionSubTitle,
  '2': T2SectionSubTitle,
  '3': T3SectionSubTitle,
  '4': T4SectionSubTitle,
};

const ParagraphTitleList = {
  '1': T1SectionParagraph,
  '2': T2SectionParagraph,
  '3': T3SectionParagraph,
  '4': T4SectionParagraph
};

const useStyles = makeStyles(() => ({
  carousel: {
    position: 'relative',
    '& .rec.rec-arrow': {
      position: 'absolute',
      backgroundColor: 'white',
      zIndex: '10',
      top: '38%',
      border: 'none',
      borderRadius: 0,
    },
    '& .rec.rec-dot': {
      backgroundColor: '#110729',
      border: 'none',
    },
    '& .rec.rec-arrow:last-child': {
      right: 0,
    },
    '& .rec.rec-arrow:hover': {
      backgroundColor: '#FAC400',
    },
    '& .rec.rec-arrow:disabled': {
      visibility: 'hidden',
    },
  },

  aboutImg:{
    boxShadow: '0px 0px 30px rgb(209,209,209)',
    "-webkit-box-shadow": '0px 0px 30px rgb(209,209,209)',
    "-moz-box-shadow": '0px 0px 30px rgb(209,209,209)'
  },

  subTitle:{
    alignSelf: 'center',
    outline: 'none',
    border: 'none',
    width: '100%',
    margin: '10px 0px',
    color:'#000',
    fontFamily: 'inherit',
    borderRadius: '8px',
    boxSizing:"border-box"
  },

  tp:{
    whiteSpace: 'pre-line',
    overflowWrap: 'break-word',
    wordBreak: 'break-word',
    fontFamily: 'inherit'
  },

  justifyFlexStart:{
    display:'flex',
    flexDirection:'column',
    justifyContent:'flex-start'
  },

  justifyFlexEnd:{
    display:'flex',
    justifyContent:'flex-end'
  },

  colDivCenter:{
    display:'flex',
    flexDirection:'column',
    alignItems:'center',
    justifyContent:'center'
  },

  colDiv_45:{
    maxWidth:'45%'
  },

  colDiv_100:{
    width:'100%'
  },

  bannerImg:{
    '& img':{
      width:'100%',
      height:'100%'
    },
  },
}));

const Home = () => {
  const { data } = useCompanyData();
  const { t, mainColor, companyDomain, isRTL, homepageSections, aboutSectionStyle } = data;
  const navigate = useNavigate();
  const { id } = useParams();

  const handleExploreServices = () => {
    navigate(companyDomain ? '/temp/services' : `/${id}/temp/services`);
  };

  const handleExploreCategories = () => {
    navigate(companyDomain ? '/temp/categories' : `/${id}/temp/categories`);
  };

  const maxServiceShow = data && data.maxDisplayItems ? data.maxDisplayItems : 4;

  useEffect(()=> {
    window.scrollTo(0, 0);
  },[]);

  const ComponentLists = {
    ...Components,
    'About': About,
    'Services': Services,
    'Courses': Courses,
    'Teams': Teams
  };

  const staticProps = {
    headerTitle: data.companyData?.name,
    headerImage: BannerImage(data),

    aboutName: data.companyData?.name,
    aboutImage: aboutImage(data),
    aboutTitle: data?.aboutTitle || '',
    aboutDescription: data.description ? data.description :  data?.companyData?.description,
    arAboutTitle: data?.arAboutTitle || '',
    arAboutDescription: data?.arAboutDescription || '',
    aboutBackgroundColor: aboutSectionStyle && aboutSectionStyle?.backgroundColor ? aboutSectionStyle?.backgroundColor : 'transparent',
    aboutBackgroundImage: aboutSectionStyle && aboutSectionStyle?.backgroundImage ? aboutSectionStyle?.backgroundImage : '',
    aboutBackgroundStyle: aboutSectionStyle && aboutSectionStyle?.backgroundStyle ? aboutSectionStyle?.backgroundStyle : '',
    aboutSectionStyle,
    courses: data.courses || [],
    services: data.products || [],
    categories: data.categories || [],
    teamMembers: data.teams || [],
    productDisplayHorizontal: data?.productDisplayHorizontal || false,
    displayDescription: data.displayProductDesc !== undefined ? data.displayProductDesc : true,
    handleExploreCategories,
    handleExploreServices,
    maxServiceShow,
    data,
    mainColor,
    isRTL,
    t
  };
  
  return (
    <>
      <HomeHeader {...staticProps} />
      {/* <Testimonial /> */}
      {homepageSections?.length ?
        React.Children.toArray(homepageSections.map((v,index) => {
          const _compName = v?.ComponentName;
          const componentName = _compName === "Content" ? `${_compName}${v?.design || 1}` : _compName;
          const DynamicComponent = v.visible ? ComponentLists[componentName] : ComponentLists['EmptyComponent'];
          return <DynamicComponent {...staticProps} contentData={v.content || {}} index={index} productType={v.value} />
        }))
      : 
      <>
        <About {...staticProps} />
        <Services {...staticProps} productType='services' />
        <Teams {...staticProps} />
      </>
      }
    </>
  );
};

const BGSectionTitle = ({ image, justify, ...props }) => {
  return (
    <Box
      width="100%"
      display="flex"
      justifyContent={justify ? justify : 'center'}
      position="absolute"
      top={0}
      m="auto"
      left="26%"
      {...props}
    >
      <ImgLazyLoad>
        <img style={{ opacity: '0.3', width: '60%' }} src={image} alt="icon" />
      </ImgLazyLoad>
    </Box>
  );
};

const HomeHeader = ({
  headerTitle,
  // data
}) => {
  const { data } = useCompanyData();
  const classes = useStyles();
  const { chatgptContent, bannerSubTitle, bannerSubTitleFontColor,bannerTitleDirection,bannerSpaceBetween, generalTitleFontSize, generalSubTitleFontSize, bannerImage, bannerImageSize, bannerPaddingBottom, bannerPaddingTop, fontFamily, bannerMaxHeight, bannerTextAlignment, bannerImageAlignment, spaceBetweenContent, isRTL, titleFontSize, subTitleFontSize, showHeaderSocialIcon=true, displayBanner=true, demoHeader,
    companyDomain,themeDesign,
    // banner
    bannerMobileArrange,bannerPcMaxHeight,bannerMobileMaxHeight, bannerTextAlign, bannerArTextAlign,bannerStyle,bannerTextGap,bannerMobileDisplay,

    // default
    buttonColor,buttonFontColor, autoButtonSize, buttonWidth, buttonHeight,buttonRadiusGeneral, buttonFontSize,
    // button
    bannerShowButton, bannerButtonColor, bannerButtonFontColor, bannerAutoButtonSize, bannerButtonWidth, bannerButtonHeight, bannerButtonRadius, bannerButtonBorder,
    bannerButtonPath, bannerButtonExternalLink, bannerButtonFontSize, bannerButtonTitle, arBannerButtonTitle,

    // image
    bannerImageAlt,bannerImageRadius, bannerImageShadow, bannerImageShadowContent,bannerImageBorder,bannerImageMaxWidth,bannerImageMaxHeight,
    bannerMobileImageDisplay=true,bannerMobileImageMaxWidth,bannerMobileImageMaxHeight,


    // text 
    bannerTextRadius,bannerTextBackground,bannerTextBorder, bannerTextPaddingTop, bannerTextPaddingBottom, bannerTextPaddingLeft, bannerTextPaddingRight
    
   } = data || {};
   const { pathname:url } = useLocation();
  const navigate = useNavigate();
  const { twitterPage, youtube,  facebookPage, instagramPage, linkedin, tiktok, telegram, snapchat } = data.companyData || {};
  const matches = useMediaQuery(theme.breakpoints.up('sm'));
  const matches2 = useMediaQuery(theme.breakpoints.down('md'));
  const matches720 = useMediaQuery('(min-width:992px)');
  const page = 'home';

  const buttonEvent = () => {
    if(bannerButtonPath) {
      var _path = url?.split('/temp')[0];
      navigate(companyDomain ? `/temp/${bannerButtonPath}` : `${_path}/temp/${bannerButtonPath}`)
    }
    else{
      window.open(bannerButtonExternalLink,'_blank')
    }
  };

  // button
  const _buttonColor = bannerButtonColor ? bannerButtonColor : buttonColor ? buttonColor : 'inherit';
  const _buttonFontColor = bannerButtonFontColor ? bannerButtonFontColor : buttonFontColor ? buttonFontColor : 'inherit';
  const _buttonWidth = bannerAutoButtonSize || autoButtonSize ? 'fit-content' : bannerButtonWidth ? `${bannerButtonWidth}px` :
  buttonWidth ? `${buttonWidth}px` : 'fit-content';
  const _buttonHeight = bannerAutoButtonSize || autoButtonSize ? 'unset' : bannerButtonHeight ? `${bannerButtonHeight}px` :
  buttonHeight ? `${buttonHeight}px` : 'unset';
  const btnRadius = bannerButtonRadius ? `${bannerButtonRadius}px` : buttonRadiusGeneral ? `${buttonRadiusGeneral}px` : '0px'; 
  const _buttonFontSize = bannerButtonFontSize ? bannerButtonFontSize : buttonFontSize ? buttonFontSize : '16';
  const buttonTitle = isRTL === 'ar' && arBannerButtonTitle ? arBannerButtonTitle : bannerButtonTitle;

  // image
  const imgRadius = bannerImageRadius ? `${bannerImageRadius}px` : '0px'; 


  const _textAlign = !matches720 || bannerTitleDirection === 'center' ? 'center' : isRTL === 'ar' && bannerArTextAlign ? bannerArTextAlign : bannerTextAlign ? bannerTextAlign : bannerTitleDirection === 'right' && page === 'home' ? isRTL === 'ar' ? 'right' : 'right' : bannerTitleDirection === 'left' && page === 'home' ? isRTL === 'ar' ? 'right' : 'left' : 'center';
  const rightPadding = isRTL === 'ar' ? (spaceBetweenContent ? `0px ${spaceBetweenContent}px 16px 0px` : '0px 20px 16px 0px') : (spaceBetweenContent ? `0px 0px 16px ${spaceBetweenContent}px` : '0px 0px 16px 20px');
  const leftPadding = isRTL === 'ar' ? (spaceBetweenContent ? `0px 0px 16px ${spaceBetweenContent}px` : '0px 0px 16px 20px') : (spaceBetweenContent ? `0px ${spaceBetweenContent}px 16px 0px` : '0px 20px 16px 0px');
  // const titleFontStyle = titleFontSize ? {fontSize:`${titleFontSize}px`} : {};
  // const subTitleFontStyle = subTitleFontSize ? {fontSize:`${subTitleFontSize}px`} : {};

  const chatgptSubTitle = isRTL === 'ar' ? chatgptContent?.['arabic']?.['sectionHead'] : chatgptContent?.['english']?.['sectionHead'];
  const title = isRTL === 'ar' && data?.arBannerTitle ? data?.arBannerTitle : data?.bannerTitle || '';

  const subTitle = chatgptSubTitle ? chatgptSubTitle : isRTL === 'ar' && data?.arBannerSubTitle ? data?.arBannerSubTitle : bannerSubTitle || '';
  const TitleComponent = themeDesign ? TitleList?.[themeDesign] : TitleList?.[3];
  const SubTitleComponent = themeDesign ? SubTitleList?.[themeDesign] : SubTitleList?.[3];

  return (
    <Header image={BannerImage(data)} position="relative"
      overflow="hidden"
      transparencyColor={data.transparentLayer ? `${data.transparentLayer?.length === 7 ? `${data.transparentLayer}${data?.transparency || 'B2'}` : data.transparentLayer}` : '#15476d99'}
      bannerStyle={data.bannerStyle ? data.bannerStyle : 'boxed'}
      displayBanner={displayBanner}
      pb={bannerPaddingBottom ? `${bannerPaddingBottom}px` : ''}
      data={data}
      bannerMobileDisplay={bannerMobileDisplay}
      page="home"
      matches={matches2}
      height={bannerPcMaxHeight || "820px"}
      mbHeight={bannerMobileMaxHeight}
    >

      <Box
        height="100%"
        display={bannerTitleDirection === 'center' || !matches720 ? "grid" : 'flex'}
        width="100%"
        flexDirection={page !== 'home' || !matches720 ? bannerMobileArrange === 'bottom' ? 'column-reverse' : 'column'  : bannerTitleDirection === 'center' ? bannerMobileArrange === 'bottom' ? "column-reverse" : 'column' : bannerTitleDirection === 'right' ? 'row-reverse' : "row"}
        justifyContent={page !== 'home' || bannerTitleDirection === 'center' || !matches720 ? 'center' : bannerTitleDirection === 'right' && bannerSpaceBetween === 'flex-start' ? 'flex-end' : bannerTitleDirection === 'right' && bannerSpaceBetween === 'flex-end' ? 'flex-start' : bannerSpaceBetween ? bannerSpaceBetween : "space-between"}
        color="white"
      >

        {!matches720 || bannerTitleDirection === 'center' ? 
          bannerMobileArrange === 'bottom' ?
          <>
            {!bannerMobileImageDisplay ?
              null
            : page === 'home' && bannerImage ?
            <div
              className={`${!matches720 || bannerTitleDirection === 'center' ? '' : ''} ${bannerTitleDirection === 'left' ? classes.justifyFlexEnd : bannerTitleDirection === 'center' ? classes.colDivCenter : ''}`}
              style={{
                alignSelf: bannerTitleDirection === 'center' ? '' : matches2 ? 'center' : page !== 'home' ? '' : bannerImageAlignment ? bannerImageAlignment : "center",
                ...(bannerTitleDirection === 'center' || !matches720 ? {justifyContent:bannerImageAlignment} : {}),
                zIndex:1
              }}
            >
              <div style={{
                width:'100%',
                ...(bannerImageMaxWidth || bannerMobileImageMaxWidth ? {maxWidth: matches720 ? (bannerTitleDirection === 'center' ? bannerImageMaxWidth ? `${bannerImageMaxWidth}px` : '100%' : '500px') : (bannerMobileImageMaxWidth ? `${bannerMobileImageMaxWidth}px` : '100%')} : {}),
                ...(matches720 && bannerImageMaxHeight ? {maxHeight: `${bannerImageMaxHeight}px`} : !matches720 && bannerMobileImageMaxHeight ? {maxHeight:`${bannerMobileImageMaxHeight}px`} : {} ),
                borderRadius: imgRadius
              }}
                className={classes.bannerImg}
                >
                <img
                  src={bannerImage}
                  alt={bannerImageAlt ? bannerImageAlt : 'banner'}
                  style={{
                    borderRadius: imgRadius,
                    ...(bannerImageBorder ? {border:bannerImageBorder} : {}),
                    ...(bannerImageShadow && bannerImageShadowContent ? {boxShadow:bannerImageShadowContent} : {})
                  }}
                />
              </div>
            </div>
            :null}

            <Box
              // pb={2}
              fontSize={{ xs: "2rem", sm: "3rem" }}
              fontFamily={'inherit'}
              zIndex={1}
              style={{textTransform:'capitalize',
                display:'flex',
                flexDirection:'column',
                ...(bannerTextGap ? {gap:`${bannerTextGap}px`} : {}),
                ...(bannerTextPaddingTop ? {paddingTop: !matches720 ? bannerStyle === 'boxed' ? '0px' : '100px' : `${bannerTextPaddingTop}px`} : {}),
                ...(bannerTextPaddingBottom ? {paddingBottom:`${bannerTextPaddingBottom}px`} : {}),
                ...(bannerTextPaddingLeft ? {paddingLeft: !matches720 ? '0px' : `${bannerTextPaddingLeft}px`} : {}),
                ...(bannerTextPaddingRight ? {paddingRight: !matches720 ? '0px' : `${bannerTextPaddingRight}px`} : {}),
                alignSelf: matches2 ? 'center' : page !== 'home' ? '' : bannerTextAlignment ? bannerTextAlignment : "center",
                ...(bannerTextBorder ? {border: bannerTextBorder} : {}),...(bannerTextBackground ? {background: bannerTextBackground} : {}),...(bannerTextRadius ? {borderRadius: `${bannerTextRadius}px`} : {})
              }}
              className={`${!matches720 || bannerTitleDirection === 'center' ? '' : classes.colDiv_45} ${bannerTitleDirection === 'left' ? classes.justifyFlexStart : ''}`}
            >
                {/* <Typography
                  style={{ fontWeight: 700, color: data.bannerFontColor ? data.bannerFontColor : 'white',textTransform:'capitalize',textAlign: _textAlign }}
                  variant={titleFontSize && textVariant?.[titleFontSize] ? textVariant?.[titleFontSize] : generalTitleFontSize && textVariant?.[generalTitleFontSize] ? textVariant?.[generalTitleFontSize] : textVariant?.['62']}
                  className={titleFontSize && textClasses?.[titleFontSize] ? textClasses?.[titleFontSize] : generalTitleFontSize && textClasses?.[generalTitleFontSize] ? textClasses?.[generalTitleFontSize] : textClasses?.['62']}
                >
                  {demoHeader || title}
                </Typography> */}
                {TitleComponent ?
                <TitleComponent {...(data.bannerFontColor ? {color: data.bannerFontColor ? data.bannerFontColor : 'white'} : {} )} contentSection={true} pFontSize={titleFontSize} wordBreak="break-word" textAlign={_textAlign}>{demoHeader || title}</TitleComponent>
                : null}
                {subTitle && page === 'home' && SubTitleComponent ?
                  <SubTitleComponent {...(bannerSubTitleFontColor ? {color: bannerSubTitleFontColor} : {} )} pFontSize={subTitleFontSize} contentSection={true} wordBreak="break-word" visibleHorizontalLine={false} textAlign={_textAlign}>{subTitle}</SubTitleComponent>

                // <Typography style={{color:bannerSubTitleFontColor || '',textAlign:_textAlign}}
                //   variant={subTitleFontSize && textVariant?.[subTitleFontSize] ? textVariant?.[subTitleFontSize] : generalSubTitleFontSize && textVariant?.[generalSubTitleFontSize] ? textVariant?.[generalSubTitleFontSize] : textVariant?.['18']}
                //   className={`${subTitleFontSize && textClasses?.[subTitleFontSize] ? textClasses?.[subTitleFontSize] : generalSubTitleFontSize && textClasses?.[generalSubTitleFontSize] ? textClasses?.[generalSubTitleFontSize] : textClasses?.['18']} ${classes.subTitle}`}
                // >
                //     <span className={classes.tp} style={{fontFamily:data?.fontFamily}}>{subTitle}</span>
                // </Typography>
                : null}

                {bannerShowButton ?
                <div style={{width:'100%',textAlign:_textAlign}}>
                  <CustomButton
                    style={{
                        backgroundColor: _buttonColor,
                        textTransform:'capitalize',
                        color: _buttonFontColor,
                        width: _buttonWidth,
                        height: _buttonHeight,
                        borderRadius: btnRadius,
                        fontFamily: 'inherit',
                        ...(bannerButtonBorder ? {border:bannerButtonBorder} : {})
                    }}
                    onClick={buttonEvent}
                    className={textClasses?.[_buttonFontSize]}
                    >
                    {buttonTitle}
                  </CustomButton>
                </div>
                : null}
            </Box>
          </>
          :
          <>
          <Box
            fontSize={{ xs: "2rem", sm: "3rem" }}
            fontFamily={'inherit'}
            zIndex={1}
            style={{textTransform:'capitalize',
              display:'flex',
              flexDirection:'column',
              ...(bannerTextGap ? {gap:`${bannerTextGap}px`} : {}),
              ...(bannerTextPaddingTop ? {paddingTop: !matches720 ? bannerStyle === 'boxed' ? '0px' : '100px' : `${bannerTextPaddingTop}px`} : {paddingTop:'10px'}),
              ...(bannerTextPaddingBottom ? {paddingBottom:`${bannerTextPaddingBottom}px`} : {paddingTop:'10px'}),
              ...(bannerTextPaddingLeft ? {paddingLeft: !matches720 ? '0px' : `${bannerTextPaddingLeft}px`} : {paddingLeft:'10px'}),
              ...(bannerTextPaddingRight ? {paddingRight: !matches720 ? '0px' : `${bannerTextPaddingRight}px`} : {paddingRight:'10px'}),
              alignSelf: matches2 ? 'center' : page !== 'home' ? '' : bannerTextAlignment ? bannerTextAlignment : "center",
              ...(bannerTextBorder ? {border: bannerTextBorder} : {}),...(bannerTextBackground ? {background: bannerTextBackground} : {}),...(bannerTextRadius ? {borderRadius: `${bannerTextRadius}px`} : {})
            }}
            className={`${!matches720 || bannerTitleDirection === 'center' ? '' : classes.colDiv_45} ${bannerTitleDirection === 'left' ? classes.justifyFlexStart : ''}`}
          >
              {/* <Typography
                style={{ fontWeight: 700, color: data.bannerFontColor ? data.bannerFontColor : 'white',textTransform:'capitalize',textAlign: _textAlign }}
                variant={titleFontSize && textVariant?.[titleFontSize] ? textVariant?.[titleFontSize] : generalTitleFontSize && textVariant?.[generalTitleFontSize] ? textVariant?.[generalTitleFontSize] : textVariant?.['62']}
                className={titleFontSize && textClasses?.[titleFontSize] ? textClasses?.[titleFontSize] : generalTitleFontSize && textClasses?.[generalTitleFontSize] ? textClasses?.[generalTitleFontSize] : textClasses?.['62']}
              >
                {demoHeader || title}
              </Typography> */}
              {TitleComponent ?
              <TitleComponent {...(data.bannerFontColor ? {color: data.bannerFontColor ? data.bannerFontColor : 'white'} : {} )} contentSection={true} pFontSize={titleFontSize} wordBreak="break-word" textAlign={_textAlign}>{demoHeader || title}</TitleComponent>
              : null}
              {subTitle && page === 'home' && SubTitleComponent ?
              <SubTitleComponent {...(bannerSubTitleFontColor ? {color: bannerSubTitleFontColor} : {} )} pFontSize={subTitleFontSize} contentSection={true} wordBreak="break-word" visibleHorizontalLine={false} textAlign={_textAlign}>{subTitle}</SubTitleComponent>

              // <Typography style={{color:bannerSubTitleFontColor || '',textAlign:_textAlign}}
              //   variant={subTitleFontSize && textVariant?.[subTitleFontSize] ? textVariant?.[subTitleFontSize] : generalSubTitleFontSize && textVariant?.[generalSubTitleFontSize] ? textVariant?.[generalSubTitleFontSize] : textVariant?.['18']}
              //   className={`${subTitleFontSize && textClasses?.[subTitleFontSize] ? textClasses?.[subTitleFontSize] : generalSubTitleFontSize && textClasses?.[generalSubTitleFontSize] ? textClasses?.[generalSubTitleFontSize] : textClasses?.['18']} ${classes.subTitle}`}
              // >
              //     <span className={classes.tp} style={{fontFamily:data?.fontFamily}}>{subTitle}</span>
              // </Typography>
              : null}

              {bannerShowButton ?
              <div style={{width:'100%',textAlign:_textAlign}}>
                <CustomButton
                  style={{
                      backgroundColor: _buttonColor,
                      textTransform:'capitalize',
                      color: _buttonFontColor,
                      width: _buttonWidth,
                      height: _buttonHeight,
                      borderRadius: btnRadius,
                      fontFamily: 'inherit',
                      ...(bannerButtonBorder ? {border:bannerButtonBorder} : {})
                  }}
                  onClick={buttonEvent}
                  className={textClasses?.[_buttonFontSize]}
                  >
                  {buttonTitle}
                </CustomButton>
              </div>
              : null}
          </Box>

          {!matches720 && !bannerMobileImageDisplay ?
          null
          : page === 'home' && bannerImage ?
          <div
            className={`${!matches720 || bannerTitleDirection === 'center' ? '' : ''} ${bannerTitleDirection === 'left' ? classes.justifyFlexEnd : bannerTitleDirection === 'center' ? classes.colDivCenter : ''}`}
            style={{
              alignSelf: bannerTitleDirection === 'center' ? '' : matches2 ? 'center' : page !== 'home' ? '' : bannerImageAlignment ? bannerImageAlignment : "center",
              ...(bannerTitleDirection === 'center' || !matches720 ? {justifyContent:bannerImageAlignment} : {}),
              zIndex:1
            }}
          >
            <div style={{
              width:'100%',
              ...(bannerImageMaxWidth || bannerMobileImageMaxWidth ? {maxWidth: matches720 ? (bannerTitleDirection === 'center' ? bannerImageMaxWidth ? `${bannerImageMaxWidth}px` : '100%' : '500px') : (bannerMobileImageMaxWidth ? `${bannerMobileImageMaxWidth}px` : '100%')} : {}),
              ...(matches720 && bannerImageMaxHeight ? {maxHeight: `${bannerImageMaxHeight}px`} : !matches720 && bannerMobileImageMaxHeight ? {maxHeight:`${bannerMobileImageMaxHeight}px`} : {} ),
              borderRadius: imgRadius
            }}
              className={classes.bannerImg}
              >
              <img
                src={bannerImage}
                alt={bannerImageAlt ? bannerImageAlt : 'banner'}
                style={{
                  borderRadius: imgRadius,
                  ...(bannerImageBorder ? {border:bannerImageBorder} : {}),
                  ...(bannerImageShadow && bannerImageShadowContent ? {boxShadow:bannerImageShadowContent} : {})
                }}
              />
            </div>
          </div>
          : null }
          </>
          :
          // desktop
          <>
          <Box
            fontSize={{ xs: "2rem", sm: "3rem" }}
            fontFamily={'inherit'}
            zIndex={1}
            style={{textTransform:'capitalize',
              display:'flex',
              flexDirection:'column',
              ...(bannerTextGap ? {gap:`${bannerTextGap}px`} : {}),
              ...(bannerTextPaddingTop ? {paddingTop: !matches720 ? bannerStyle === 'boxed' ? '0px' : '100px' : `${bannerTextPaddingTop}px`} : {}),
              ...(bannerTextPaddingBottom ? {paddingBottom:`${bannerTextPaddingBottom}px`} : {}),
              ...(bannerTextPaddingLeft ? {paddingLeft: !matches720 ? '0px' : `${bannerTextPaddingLeft}px`} : {}),
              ...(bannerTextPaddingRight ? {paddingRight: !matches720 ? '0px' : `${bannerTextPaddingRight}px`} : {}),
              alignSelf: matches2 ? 'center' : page !== 'home' ? '' : bannerTextAlignment ? bannerTextAlignment : "center",
              ...(bannerTextBorder ? {border: bannerTextBorder} : {}),...(bannerTextBackground ? {background: bannerTextBackground} : {}),...(bannerTextRadius ? {borderRadius: `${bannerTextRadius}px`} : {})
            }}
            className={`${!matches720 || bannerTitleDirection === 'center' ? '' : classes.colDiv_45} ${bannerTitleDirection === 'left' ? classes.justifyFlexStart : ''}`}
          >
              {/* <Typography
                style={{ fontWeight: 700, color: data.bannerFontColor ? data.bannerFontColor : 'white',textTransform:'capitalize',textAlign: _textAlign }}
                variant={titleFontSize && textVariant?.[titleFontSize] ? textVariant?.[titleFontSize] : generalTitleFontSize && textVariant?.[generalTitleFontSize] ? textVariant?.[generalTitleFontSize] : textVariant?.['62']}
                className={titleFontSize && textClasses?.[titleFontSize] ? textClasses?.[titleFontSize] : generalTitleFontSize && textClasses?.[generalTitleFontSize] ? textClasses?.[generalTitleFontSize] : textClasses?.['62']}
              >
                {demoHeader || title}
              </Typography> */}
              {TitleComponent ?
              <TitleComponent {...(data.bannerFontColor ? {color: data.bannerFontColor ? data.bannerFontColor : 'white'} : {} )} contentSection={true} pFontSize={titleFontSize} wordBreak="break-word" textAlign={_textAlign}>{demoHeader || title}</TitleComponent>
              : null}
              {subTitle && page === 'home' && SubTitleComponent ?
              // <></>
              <SubTitleComponent {...(bannerSubTitleFontColor ? {color: bannerSubTitleFontColor} : {} )} contentSection={true} pFontSize={subTitleFontSize} wordBreak="break-word" visibleHorizontalLine={false} textAlign={_textAlign}>{subTitle}</SubTitleComponent>

              // <Typography style={{color:bannerSubTitleFontColor || '',textAlign:_textAlign}}
              //   variant={subTitleFontSize && textVariant?.[subTitleFontSize] ? textVariant?.[subTitleFontSize] : generalSubTitleFontSize && textVariant?.[generalSubTitleFontSize] ? textVariant?.[generalSubTitleFontSize] : textVariant?.['18']}
              //   className={`${subTitleFontSize && textClasses?.[subTitleFontSize] ? textClasses?.[subTitleFontSize] : generalSubTitleFontSize && textClasses?.[generalSubTitleFontSize] ? textClasses?.[generalSubTitleFontSize] : textClasses?.['18']} ${classes.subTitle}`}
              // >
              //     <span className={classes.tp} style={{fontFamily:data?.fontFamily}}>{subTitle}</span>
              // </Typography>
              : null}

              {bannerShowButton ?
              <div style={{width:'100%',textAlign:_textAlign}}>
                <CustomButton
                  style={{
                      backgroundColor: _buttonColor,
                      textTransform:'capitalize',
                      color: _buttonFontColor,
                      width: _buttonWidth,
                      height: _buttonHeight,
                      borderRadius: btnRadius,
                      fontFamily: 'inherit',
                      ...(bannerButtonBorder ? {border:bannerButtonBorder} : {})
                  }}
                  onClick={buttonEvent}
                  className={textClasses?.[_buttonFontSize]}
                  >
                  {buttonTitle}
                </CustomButton>
              </div>
              : null}
          </Box>

          {!bannerMobileImageDisplay ?
          null
          : page === 'home' && bannerImage ?
          <div
            className={`${!matches720 || bannerTitleDirection === 'center' ? '' : ''} ${bannerTitleDirection === 'left' ? classes.justifyFlexEnd : bannerTitleDirection === 'center' ? classes.colDivCenter : ''}`}
            style={{
              alignSelf: bannerTitleDirection === 'center' ? '' : matches2 ? 'center' : page !== 'home' ? '' : bannerImageAlignment ? bannerImageAlignment : "center",
              ...(bannerTitleDirection === 'center' || !matches720 ? {justifyContent:bannerImageAlignment} : {}),
              zIndex:1
            }}
          >
            <div style={{
              width:'100%',
              ...(matches720 && bannerImageMaxWidth ? {maxWidth: bannerImageMaxWidth ? `${bannerImageMaxWidth}px` : '100%'} : !matches720 && bannerMobileImageMaxWidth ? {maxWidth: (bannerMobileImageMaxWidth ? `${bannerMobileImageMaxWidth}px` : '100%')} : {}),
              ...(matches720 && bannerImageMaxHeight ? {maxHeight: `${bannerImageMaxHeight}px`} : !matches720 && bannerMobileImageMaxHeight ? {maxHeight:`${bannerMobileImageMaxHeight}px`} : {} ),
              borderRadius: imgRadius
            }}
              className={classes.bannerImg}
              >
              <img
                src={bannerImage}
                alt={bannerImageAlt ? bannerImageAlt : 'banner'}
                style={{
                  borderRadius: imgRadius,
                  ...(bannerImageBorder ? {border:bannerImageBorder} : {}),
                  ...(bannerImageShadow && bannerImageShadowContent ? {boxShadow:bannerImageShadowContent} : {})
                }}
              />
            </div>
          </div>
          : null }
          </>
        }
      </Box>
      <Box
        width="100%"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        position="absolute"
        left="0"
        bottom="20px"
        zIndex={1}
      >
        { showHeaderSocialIcon ?
        <SocialIcons
          color="white"
          mb={2}
          border="1px solid white"
          twitterLink={twitterPage}
          youtubeLink={youtube}
          facebookLink={facebookPage}
          instagramLink={instagramPage}
          linkedinLink={linkedin}
          tiktokLink={tiktok}
          telegramLink={telegram}
          snapchatLink={snapchat}
        />
        : null }
      </Box>
    </Header>
  );
};

function About({ aboutTitle, aboutName, aboutImage, aboutDescription, arAboutTitle, arAboutDescription, aboutBackgroundColor, aboutBackgroundImage, aboutBackgroundStyle, isRTL, t, data, mainColor, aboutSectionStyle }) {
  const isMounted = React.useRef(null);
  const [imageDimensions, setImageDimensions] = React.useState({});
  const matches = useMediaQuery(theme.breakpoints.up('lg'));
  const matches720 = useMediaQuery('(min-width:720px)');
  const classes = useStyles();
  const [showLess, setShowLess] = React.useState(true);
  const textLength = 800;
  const { buttonColor, buttonFontColor, generalParagraphFontSize, generalParagraphColor } = data || {};
  const { titleFormat, titleFontSize, subTitleFontSize, descriptionFontSize, titleFontColor, subTitleFontColor, textFontColor, paddingTop, paddingBottom } = aboutSectionStyle || {};
  const _descriptionFontSize = descriptionFontSize ? descriptionFontSize : generalParagraphFontSize ? generalParagraphFontSize : '16';
  const descFontColor = textFontColor ? textFontColor : generalParagraphColor ? generalParagraphColor : '#000';

  const desc = isRTL === 'ar' && arAboutDescription ? arAboutDescription : aboutDescription;
  const title = isRTL === 'ar' && arAboutTitle ? arAboutTitle : aboutTitle || t && t('companyPage.aboutus');

  React.useEffect(() => {
    function run() {
      isMounted.current = true;
      if(isMounted.current) {
        GetImageDimensions(setImageDimensions, aboutImage);
      }
    };

    run();
    return () => isMounted.current = false;
  }, [aboutImage]);

  return (
      <div style={{
        width:'100%',
        ...(aboutBackgroundStyle === 'image' && aboutBackgroundImage ?
        {
          backgroundImage: `url(${aboutBackgroundImage})`,
          backgroundSize: "cover"
        }
        :
        aboutBackgroundStyle === 'gradient' ? 
        {backgroundImage: aboutBackgroundColor} 
        : {backgroundColor: aboutBackgroundColor}
        )
      }}>
        <SectionLayout paddingTop={paddingTop} paddingBottom={paddingBottom}>
          <Box
            display="flex"
            flexDirection={matches720 ? 'row' : 'column-reverse'}
            alignItems="center"
            justifyContent="center"
            width="100%"
            m="auto"
            position="relative"
          >
            <BGSectionTitle justify="unset" image={imgAbout} left={0} top="-61px" />

            <Box
              width="auto"
              maxWidth='45%'
              height="auto"
              maxHeight="438px"
              overflow="hidden"
              borderRadius="15px"
              className={classes.aboutImg}
            >
              <ImgLazyLoad>
                <img
                  style={{
                    width:"100%",
                    height:"auto",
                    maxHeight: "438px",
                    borderRadius:"15px",
                    ...(imageDimensions?.height > 1280 ? {objectFit:'cover'} : {})
                  }}
                  src={data.aboutImage ? data.aboutImage : aboutImage}
                  alt={aboutName || 'about'}
                />
              </ImgLazyLoad>
            </Box>
            <Box
              mb={matches720 ? 0 : 4}
              width={matches720 ? '49%' : '100%'}
              minWidth="300px"
              style={{margin:'0px 30px'}}
              textAlign={!matches720 ? 'center' : 'initial'}
            >
              <Box
                display={matches720 ? 'block' : 'flex'}
                flexDirection="column"
                alignItems="center"
              >
                <SectionSubtitle pFontSize={subTitleFontSize} color={subTitleFontColor} mainColor={mainColor}>{t && t('companyPage.ourGoals')}</SectionSubtitle>
                <SectionTitle pFontSize={titleFontSize} color={titleFontColor} variant={titleFormat}>{title}</SectionTitle>
              </Box>

              <Box pb={3} textAlign={matches720 ? 'left' : 'center'} color={descFontColor}>
                <Typography 
                variant={_descriptionFontSize && textVariant?.[_descriptionFontSize] ? textVariant?.[_descriptionFontSize] : textVariant?.['16']}
                className={_descriptionFontSize && textClasses?.[_descriptionFontSize] ? textClasses?.[_descriptionFontSize] : textClasses?.['16']}
                 style={{ opacity: '0.8' }}>
                  {desc && desc.length < textLength ? desc
                  : showLess ? desc && desc.slice(0,textLength)
                  : desc
                  }
                </Typography>
              </Box>

              {desc && desc.length < textLength ?
              null :
              <Box textAlign={matches720 ? 'left' : 'center'}>
                <CustomButton
                  style={{backgroundColor: buttonColor ? buttonColor : 'inherit',color:buttonFontColor ? buttonFontColor : 'inherit'}}
                  onClick={showLess ? ()=> setShowLess(false) : ()=> setShowLess(true)}
                  endIcon={
                    isRTL === 'en' ? (
                      <ArrowForward
                        style={{ fontSize: '1.2rem', margin: '0 0.2em' }}
                      />
                    ) : (
                      <ArrowBack
                        style={{ fontSize: '1.2rem', margin: '0 0.2em' }}
                      />
                    )
                  }
                >
                  {showLess ? t && t('companyPage.readMore') : t && t('companyPage.showless')}
                </CustomButton>
              </Box>
              }
            </Box>
          </Box>
        </SectionLayout>
      </div>
    );
}

function Services({ services, categories, t, handleExploreServices, handleExploreCategories,productType, data, mainColor, contentData, index }) {
  const isMounted = React.useRef(null);
  const matches = useMediaQuery(theme.breakpoints.up('md'));
  const { maxDisplayItems, displayProductDesc, productDisplayHorizontal = true, backgroundColor, backgroundImage, backgroundStyle, categoryId, title, arTitle, subTitle, arSubTitle, selectedCategories, titleFormat, titleFontSize, subTitleFontSize, titleFontColor, subTitleFontColor, paddingTop, paddingBottom } = contentData || {};
  const displayDescription = displayProductDesc !== undefined ? displayProductDesc : true;
  const maxServiceShow = maxDisplayItems ? maxDisplayItems : 4;
  const [showItems,setItems] = useState(4); 
  const classes = useStyles();
  const { buttonColor, buttonFontColor, chatgptContent, isRTL } = data || {};

  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 900, itemsToShow: 2 },
    { width: 1000, itemsToShow: 3 },
  ];

  const _title = title
  ? getLocalizedText(title, arTitle,isRTL)
  : productType === 'categories'
  ? t?.('companyPage.category')
  : t?.('companyPage.services');

  const _subTitle = subTitle
  ? getLocalizedText(subTitle, arSubTitle,isRTL)
  : productType === 'categories'
  ? t?.('companyPage.topCategories')
  : t?.('companyPage.topServices');

  const servicesDuplicate = services?.length ? JSON.parse(JSON.stringify(services)) : [];
  const filterService = servicesDuplicate?.length && categoryId && servicesDuplicate.filter(v=> v.serviceCategoryId === categoryId)?.length ? 
  servicesDuplicate.filter(v=> v.serviceCategoryId === categoryId) : 
  servicesDuplicate;

  React.useEffect(() => {
    isMounted.current = true;

    setItems(maxServiceShow)
    return () => isMounted.current = false;
  }, [maxServiceShow]);

  const companyId = data?.companyData ? data?.companyData?.companyId : '';
  const filteredSelectedCategory = selectedCategories?.length && categories ?  categories?.filter(category => selectedCategories.includes(category.id)) : [];
  const renderList = productType === 'categories' ? selectedCategories?.length && filteredSelectedCategory?.length ? filteredSelectedCategory : categories : filterService;
  const filterCategories = filteredSelectedCategory?.length ? filteredSelectedCategory : categories;

  const expendCategories = () =>{
    setItems(categories?.length)
  };

  function RenderItems() {
    return(
      productType === 'categories' ?
      filterCategories?.slice(0, maxServiceShow).map((item, i) => (
          <ServiceCard
            key={i}
            service={{
              ...item,
              name: chatgptContent && Object?.keys(chatgptContent)?.length ? (isRTL === 'ar' ? 
                chatgptContent?.['arabic']?.[`section${index}`]?.[i]?.['title'] : chatgptContent?.['english']?.[`section${index}`]?.[i]?.['title'])
                : item.name,
              description: chatgptContent && Object?.keys(chatgptContent)?.length ? (isRTL === 'ar' ? 
                chatgptContent?.['arabic']?.[`section${index}`]?.[i]?.['description'] : chatgptContent?.['english']?.[`section${index}`]?.[i]?.['description'])
                : item.description
            }}
           {...{displayDescription,productType,companyId,contentData}}
          />
        ))
      :
      filterService?.slice(0, maxServiceShow).map((item, i) => (
        <ServiceCard
          key={i}
          service={{
            ...item,
            name: chatgptContent && Object?.keys(chatgptContent)?.length ? 
              (isRTL === 'ar' ? 
                chatgptContent?.['arabic']?.[`section${index}`]?.[i]?.['title'] : chatgptContent?.['english']?.[`section${index}`]?.[i]?.['title']
              )
              : item.name,
            shortDescription: chatgptContent && Object?.keys(chatgptContent)?.length ? (isRTL === 'ar' ? 
                chatgptContent?.['arabic']?.[`section${index}`]?.[i]?.['description'] : chatgptContent?.['english']?.[`section${index}`]?.[i]?.['description'])
                : item.shortDescription
          }}
          {...{displayDescription,companyId,contentData}}
        />
      ))
    )
  };

  if(filterService?.length > 0 || filterCategories?.length > 0) {
    return (
      <Box
        style={{
          width:'100%',
          ...(backgroundStyle === 'image' && backgroundImage ?
            {
              backgroundImage: `url(${backgroundImage})`,
              backgroundSize: "cover",
              backgroundRepeat: 'no-repeat',
            }
            :
            backgroundStyle === 'gradient' ? 
            {backgroundImage: backgroundColor} 
            : {backgroundColor: backgroundColor || 'transparent'}
          )
        }}
      >
        <SectionLayout paddingTop={paddingTop} paddingBottom={paddingBottom}>
        <Box width="100%" m="auto" position="relative">
          <BGSectionTitle image={imgServices} left="0" />

          <Box display="flex" flexDirection="column" alignItems="center">
            <SectionSubtitle pFontSize={subTitleFontSize} color={subTitleFontColor} mainColor={mainColor}>{_title}</SectionSubtitle>
            <SectionTitle pFontSize={titleFontSize} color={titleFontColor} variant={titleFormat}>{_subTitle}</SectionTitle>
          </Box>
          <Box pb={3} display="flex" flexDirection={!productDisplayHorizontal ? 'row' : 'unset'} flexWrap={!productDisplayHorizontal ? 'wrap' : 'unset'} justifyContent="center">
                {!productDisplayHorizontal ?
                  <RenderItems />
                :
                <Carousel className={classes.carousel} breakPoints={breakPoints}>
                  {
                    productType === 'categories' ?
                    filterCategories?.slice(0, maxServiceShow).map((item, i) => (
                      <ServiceCard key={i}
                        service={{
                          ...item,
                          name: chatgptContent && Object?.keys(chatgptContent)?.length ? (isRTL === 'ar' ? 
                            chatgptContent?.['arabic']?.[`section${index}`]?.[i]?.['title'] : chatgptContent?.['english']?.[`section${index}`]?.[i]?.['title'])
                            : item.name,
                          description: chatgptContent && Object?.keys(chatgptContent)?.length ? (isRTL === 'ar' ? 
                            chatgptContent?.['arabic']?.[`section${index}`]?.[i]?.['description'] : chatgptContent?.['english']?.[`section${index}`]?.[i]?.['description'])
                            : item.description
                        }}
                        {...{displayDescription,productType,companyId,contentData}}
                      />
                    ))
                  :
                    filterService?.slice(0, maxServiceShow).map((item, i) => (
                      <ServiceCard key={i}
                        service={{
                          ...item,
                          name: chatgptContent && Object?.keys(chatgptContent)?.length ? (isRTL === 'ar' ? 
                            chatgptContent?.['arabic']?.[`section${index}`]?.[i]?.['title'] : chatgptContent?.['english']?.[`section${index}`]?.[i]?.['title'])
                            : item.name,
                          shortDescription: chatgptContent && Object?.keys(chatgptContent)?.length ? (isRTL === 'ar' ? 
                            chatgptContent?.['arabic']?.[`section${index}`]?.[i]?.['description'] : chatgptContent?.['english']?.[`section${index}`]?.[i]?.['description'])
                            : item.shortDescription
                        }}
                        {...{displayDescription,companyId,contentData}}
                      />
                    ))
                  }
                </Carousel>
                }
          </Box>
            {/* {productType === 'services' ?
            <Box textAlign="center" display="flex" flexDirection="column" alignItems={!matches ? 'center' : 'flex-end'}>
              <CustomButton variant="contained" style={{backgroundColor: buttonColor ? buttonColor : 'inherit',color:buttonFontColor ? buttonFontColor : 'inherit'}} onClick={productType === 'categories' ? handleExploreCategories : handleExploreServices}>
                {t && t('companyPage.exploreServices')}
              </CustomButton>
            </Box>
            : null} */}
        </Box>
        </SectionLayout>
      </Box>
    );
  };

  return null;
}

function Courses({ courses, data, mainColor, contentData, t }) {
  const isMounted = React.useRef(null);
  const matches = useMediaQuery(theme.breakpoints.up('md'));
  const { maxDisplayItems, displayProductDesc, productDisplayHorizontal = true, backgroundColor, backgroundImage, backgroundStyle, categoryId, title, arTitle, subTitle, arSubTitle, titleFormat, titleFontSize, subTitleFontSize, titleFontColor, subTitleFontColor, paddingTop, paddingBottom } = contentData || {};
  const displayDescription = displayProductDesc !== undefined ? displayProductDesc : true;
  const maxServiceShow = maxDisplayItems ? maxDisplayItems : 4;
  const [showItems,setItems] = useState(4); 
  const classes = useStyles();
  const { buttonColor, buttonFontColor, chatgptContent, isRTL } = data || {};
  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 900, itemsToShow: 2 },
    { width: 1000, itemsToShow: 3 },
  ];

  const _title = title ? (isRTL === 'ar' ? (arTitle ? arTitle : title) : title) : t && t('courses.title');
  const _subTitle = subTitle ? (isRTL === 'ar' ? (arSubTitle ? arSubTitle : subTitle) : subTitle) : t && t('courses.topCourses');

  const coursesDuplicate = courses?.length ? JSON.parse(JSON.stringify(courses)) : [];
  const filterCourse = coursesDuplicate?.length && categoryId && coursesDuplicate.filter(v=> v.courseCategoryId === categoryId)?.length ? 
  coursesDuplicate.filter(v=> v.courseCategoryId === categoryId) : 
  coursesDuplicate;

  React.useEffect(() => {
    isMounted.current = true;

    setItems(maxServiceShow)
    return () => isMounted.current = false;
  }, [maxServiceShow]);

  const companyId = data?.companyData ? data?.companyData?.companyId : '';
  const renderList = filterCourse;


  function RenderItems() {
    return(
        filterCourse?.slice(0, maxServiceShow).map((item, i) => (
          <CourseCard
            key={i}
            service={item}
           {...{displayDescription,companyId,contentData}}
          />
        ))
    )
  };

  if(filterCourse?.length > 0) {
    return (
      <Box
        style={{
          width:'100%',
          ...(backgroundStyle === 'image' && backgroundImage ?
            {
              backgroundImage: `url(${backgroundImage})`,
              backgroundSize: "cover",
              backgroundRepeat: 'no-repeat',
            }
            :
            backgroundStyle === 'gradient' ? 
            {backgroundImage: backgroundColor} 
            : {backgroundColor: backgroundColor || 'transparent'}
          )
        }}
      >
        <SectionLayout paddingTop={paddingTop} paddingBottom={paddingBottom}>
        <Box width="100%" m="auto" position="relative">
          <BGSectionTitle image={imgServices} left="0" />

          <Box display="flex" flexDirection="column" alignItems="center">
            <SectionSubtitle pFontSize={subTitleFontSize} color={subTitleFontColor} mainColor={mainColor}>{_title}</SectionSubtitle>
            <SectionTitle pFontSize={titleFontSize} color={titleFontColor} variant={titleFormat}>{_subTitle}</SectionTitle>
          </Box>
          <Box pb={3} display="flex" flexDirection={!productDisplayHorizontal ? 'row' : 'unset'} flexWrap={!productDisplayHorizontal ? 'wrap' : 'unset'} justifyContent="center">
                {!productDisplayHorizontal ?
                  <RenderItems />
                :
                <Carousel className={classes.carousel} breakPoints={breakPoints}>
                  {
                    filterCourse?.slice(0, maxServiceShow).map((item, i) => (
                      <CourseCard
                        key={i}
                        service={item}
                        {...{displayDescription,companyId,contentData}}
                      />
                    ))
                  }
                </Carousel>
                }
          </Box>
        </Box>
        </SectionLayout>
      </Box>
    );
  };

  return null;
}

function Teams({ teamMembers, t, mainColor,data, contentData }) {
  const matches = useMediaQuery(theme.breakpoints.up('md'));
  const { setPage, count, currentItems } = useMyPagination(teamMembers, 6);
  const [isExpanded, setIsExpanded] = useState(false);
  const { buttonColor, buttonFontColor, companyDomain } = data || {};
  const { backgroundColor, backgroundImage, backgroundStyle, titleFormat, titleFontSize, subTitleFontSize, titleFontColor, subTitleFontColor, paddingTop, paddingBottom } = contentData || {};
  
  if(teamMembers?.length)
  return (
    <div
    style={{
      width:'100%',
      ...(backgroundStyle === 'image' && backgroundImage ?
        {
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundRepeat: 'no-repeat',
        }
        :
        backgroundStyle === 'gradient' ? 
        {backgroundImage: backgroundColor} 
        : 
        {backgroundColor: backgroundColor || 'transparent'}
      )
    }}
    >
      <SectionLayout paddingTop={paddingTop} paddingBottom={paddingBottom}>
        <Box width="100%" m="auto">
          <Box
            display="flex"
            flexDirection={matches ? 'row' : 'column'}
            justifyContent="space-between"
            position="relative"
          >

            <Box
              width={matches ? '30%' : '100%'}
              mr={1}
              display={matches ? 'block' : 'flex'}
              flexDirection="column"
              alignItems="center"
            >
              <SectionSubtitle pFontSize={subTitleFontSize} color={subTitleFontColor} mainColor={mainColor}>
                {t && t('companyPage.outProfessionalTeam')}
              </SectionSubtitle>
              <SectionTitle pFontSize={titleFontSize} color={titleFontColor} variant={titleFormat}>{t && t('companyPage.team')}</SectionTitle>
            </Box>
            {matches ? (
              <div style={{ width: '65%',position:'relative' }}>
                <BGSectionTitle image={imgTeam} left="0%" top="-70px" />

                <Box
                  width="100%"
                  display="flex"
                  justifyContent="flex-end"
                  flexWrap="wrap"
                >
                  {currentItems?.map((item, i) => (
                    <TeamMember key={i} member={item} companyDomain={companyDomain} />
                  ))}
                </Box>

                <MyPagination count={count} onChange={setPage} />
              </div>
            ) : (
              <Box
                width="100%"
                display="flex"
                justifyContent="center"
                alignItems="center"
                flexDirection="column"
                position="relative"
              >
                <BGSectionTitle image={imgTeam} left="0%" top="-16%" />
                {teamMembers
                  ?.slice(0, isExpanded ? teamMembers.length : 3)
                  ?.map((item, i) => (
                    <TeamMember key={i} member={item} companyDomain={companyDomain} />
                  ))}
              </Box>
            )}
          {/* </div> */}
          </Box>
          {!matches && (
            <Box textAlign="center" my={3}>

              {isExpanded ? (
                <CustomButton
                  style={{backgroundColor: buttonColor ? buttonColor : 'inherit',color:buttonFontColor ? buttonFontColor : 'inherit'}}
                  variant="contained"
                  onClick={() => setIsExpanded(false)}
                >
                  {t && t('companyPage.seeLess')}
                </CustomButton>
              ) : (
                <CustomButton
                  style={{backgroundColor: buttonColor ? buttonColor : 'inherit',color:buttonFontColor ? buttonFontColor : 'inherit'}}
                  variant="contained"
                  onClick={() => setIsExpanded(true)}
                >
                  {t && t('companyPage.seeMore')}
                </CustomButton>
              )}
            </Box>
          )}
        </Box>
      </SectionLayout>
    </div>
  );

  return null;
}

const TeamMember = ({ member, companyDomain }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  
  const handleClick = (_id) => {
    navigate(companyDomain ? `/temp/team/${_id}` : `/${id}/temp/team/${_id}`);
  };

  return (
    <Box width="30%" minWidth="250px" height="300px" position="relative" style={{cursor:"pointer"}} onClick={()=> handleClick(member?.id)}>
      <ImgLazyLoad>
        <img
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          src={member?.avatar || imgProfile}
          alt={member.name || 'team'}
        />
      </ImgLazyLoad>

      <Box
        position="absolute"
        width="100%"
        bottom={0}
        left={0}
        color="white"
        py={1}
        bgcolor="rgba(17, 7, 41,0.5)"
      >
        <Typography variant="subtitle1" style={{ padding: '0 1em',fontWeight:'bold',textTransform:'capitalize' }}>
          {member.name}
        </Typography>
        <Typography
          variant="subtitle2"
          style={{ textTransform: 'capitalize', padding: '0 1em',fontWeight:'normal' }}
        >
          {member.roleType}
        </Typography>
      </Box>
    </Box>
  );
};

export {
  About,
  Services,
  Courses,
  Teams,
  HomeHeader,
  BGSectionTitle
};

export default Home;
